import {
  useCurrentWorkspace,
  useWorkspaceRoutine,
} from '@gripp/shared-logic';
import { LoadingIndicator, RoutineForm, RoutineModules } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';

type RoutinePreviewColumnProps = {
  basePath?: string;
  routineId?: string;
};

export const RoutinePreviewColumn = ({
  basePath = '/new-routines',
  routineId: routineIdProp,
}: RoutinePreviewColumnProps) => {
  const params = useParams<{ routineId: string }>();
  const routineId = routineIdProp ?? params.routineId;
  const navigate = useNavigate();
  const currentWorkspace = useCurrentWorkspace();
  const routine = useWorkspaceRoutine(routineId ?? '');

  if (!routineId || !routine) {
    return <LoadingIndicator />;
  }

  const module = routine.type ? RoutineModules[routine.type] : undefined;

  if (!module) {
    return null;
  }

  return (
    <View style={styles.container}>
      <RoutineForm
        workspaceAsset={{ workspace: currentWorkspace } as any}
        module={module}
        routine={routine}
        onCompleted={async () => {
          navigate(basePath);
        }}
        onCancel={() => navigate(basePath)}
        topBar={() => <></>}
        preview={true}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
